"use strict";

import angular from "angular";

import template from "./need-help.component.html";
import "./need-help.component.scss";

class NeedHelpComponent {
    constructor(ChatHubsbotService) {
        this.ChatHubsbotService = ChatHubsbotService;
    }

    $onInit() {}

    onOpenChat() {
        this.ChatHubsbotService.open();
    }
}

NeedHelpComponent.$inject = ["ChatHubsbotService"];

const component = {
    controller: NeedHelpComponent,
    bindings: {}
};

const name = "needHelpComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
